import { ICONS as t, FORM_ICONS as e, LOGO_ICONS as r } from "./constants.js";
function i(n) {
  return typeof n == "string" && t.includes(n);
}
function s(n) {
  return typeof n == "string" && e.includes(n);
}
function u(n) {
  return typeof n == "string" && r.includes(n);
}
export {
  s as isFormIconName,
  i as isIconName,
  u as isLogoIconName
};
//# sourceMappingURL=typeGuards.js.map
